<div class="Alert">
  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>Confirmation</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <p [innerHTML]="message"></p>
  </ion-content>

  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          class="Alert__Button"
          (click)="cancel()"
          color="medium"
          fill="outline"
        >
          Cancel
        </ion-button>
        <ion-button
          class="Alert__Button"
          (click)="continue()"
          color="danger"
          fill="solid"
        >
          Continue
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</div>
